/**
 * @todo Удалить файл
 * @description Данный функционал появился в задаче CD-194493, будет удалён в задаче CD-194545
 */

import { IApplicationState } from '../../types/redux';

export const NEWBUILDING_NEW_DESIGN_TGB_ON_LISTING_EXPERIMENT = 'newbuilding_new_design_tgb_on_listing';

export function isNewbuildingNewDesignTgbOnListingExpEnabledSelector(state: IApplicationState): boolean {
  if (!state.config.isNewbuildingNewDesignTgbOnListingEnabled) {
    return false;
  }

  const abUseExperiment = state.abUseExperiments.find(
    exp => exp.experimentName === NEWBUILDING_NEW_DESIGN_TGB_ON_LISTING_EXPERIMENT,
  );

  return !!abUseExperiment && abUseExperiment.groupName === 'new_tgb';
}
